import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Grid,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';

interface FinanceDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  title: string;
  formData: any;
  onFormChange: (field: string, value: any) => void;
  currencies: any[];
  countries: any[];
}

const FinanceDialog: React.FC<FinanceDialogProps> = ({
  open,
  onClose,
  onSubmit,
  title,
  formData,
  onFormChange,
  currencies,
  countries,
}) => {
  const renderFormFields = () => {
    if (title.includes('страну')) {
      return (
        <>
          <TextField
            fullWidth
            label="Название"
            name="name"
            value={formData.name || ''}
            onChange={(e) => onFormChange('name', e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="ISO код"
            name="iso_code"
            value={formData.iso_code || ''}
            onChange={(e) => onFormChange('iso_code', e.target.value.toUpperCase().slice(0, 3))}
            margin="normal"
            required
            inputProps={{ maxLength: 3 }}
            helperText="Максимум 3 символа"
          />
        </>
      );
    }

    if (title.includes('валюту')) {
      return (
        <>
          <TextField
            fullWidth
            label="ISO код"
            name="iso_code"
            value={formData.iso_code || ''}
            onChange={(e) => onFormChange('iso_code', e.target.value.toUpperCase().slice(0, 3))}
            margin="normal"
            required
            inputProps={{ maxLength: 3 }}
            helperText="Максимум 3 символа"
          />
        </>
      );
    }

    if (title.includes('платежную систему')) {
      return (
        <>
          <TextField
            fullWidth
            label="Название"
            name="token"
            value={formData.token || ''}
            onChange={(e) => onFormChange('token', e.target.value)}
            margin="normal"
            required
          />
          <FormControl fullWidth margin="normal" required>
            <InputLabel>Валюта</InputLabel>
            <Select
              name="currency_id"
              value={formData.currency_id || ''}
              onChange={(e) => onFormChange('currency_id', e.target.value)}
              label="Валюта"
            >
              {currencies.map((currency) => (
                <MenuItem key={currency.id} value={currency.id}>
                  {currency.iso_code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {!formData.id && (
            <FormControl fullWidth margin="normal" required>
              <InputLabel>Направление</InputLabel>
              <Select
                name="supports_payout_out"
                value={formData.supports_payout_out ? 'OUT' : 'IN'}
                onChange={(e) => onFormChange('supports_payout_out', e.target.value === 'OUT')}
                label="Направление"
              >
                <MenuItem value="IN">IN</MenuItem>
                <MenuItem value="OUT">OUT</MenuItem>
              </Select>
            </FormControl>
          )}
        </>
      );
    }

    return (
      <>
        <TextField
          fullWidth
          label="Название"
          name="name"
          value={formData.name || ''}
          onChange={(e) => onFormChange('name', e.target.value)}
          margin="normal"
          required
        />
        <FormControl fullWidth margin="normal" required>
          <InputLabel>Страна</InputLabel>
          <Select
            name="country_id"
            value={formData.country_id || ''}
            onChange={(e) => onFormChange('country_id', e.target.value)}
            label="Страна"
          >
            {countries.map((country) => (
              <MenuItem key={country.id} value={country.id}>
                {country.name} ({country.iso_code})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {renderFormFields()}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button onClick={onSubmit} variant="contained" color="primary">
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FinanceDialog; 